import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tab-content" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "color-list" }
const _hoisted_4 = { class: "color-item-inner radius-middle" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "wrap" }
const _hoisted_7 = { class: "fake-input-wrap" }
const _hoisted_8 = { style: {"margin-left":"0.3vw"} }
const _hoisted_9 = { class: "wrap" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "fake-input-wrap" }
const _hoisted_12 = { style: {"margin-left":"0.3vw"} }
const _hoisted_13 = { class: "wrap" }
const _hoisted_14 = { class: "title" }
const _hoisted_15 = { class: "fake-input-wrap" }
const _hoisted_16 = { style: {"margin-left":"0.3vw"} }
const _hoisted_17 = { class: "wrap" }
const _hoisted_18 = { class: "title" }
const _hoisted_19 = { class: "fake-input-wrap" }
const _hoisted_20 = { style: {"margin-left":"0.3vw"} }
const _hoisted_21 = { class: "wrap" }

import {ref} from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'textstyle',
  emits: 'change',
  setup(__props, { emit: __emit }) {

const emits = __emit;

const colorList = ref([
  {
    class: 'text-style-1'
  }, {
    class: 'text-style-2'
  }, {
    class: 'text-style-3'
  }, {
    class: 'text-style-4'
  }, {
    class: 'text-style-5'
  }, {
    class: 'text-style-6'
  }, {
    class: 'text-style-7'
  }, {
    class: 'text-style-8'
  }, {
    class: 'text-style-9'
  }, {
    class: 'text-style-10'
  }, {
    class: 'text-style-11'
  }, {
    class: 'text-style-12'
  }, {
    class: 'text-style-13'
  }, {
    class: 'text-style-14'
  }, {
    class: 'text-style-15'
  }, {
    class: 'text-style-16'
  }, {
    class: 'text-style-17'
  }, {
    class: 'text-style-18'
  }, {
    class: 'text-style-19'
  }
])

const handleSelectColor = (item) => {
  form.value.class = item.class;
  onTextFormChange();
}

const form = ref({
  class:'',
  color: '#000',
  fontSize: 12,
  backgroundColor: '',
  stroke:'',
  strokeWidth: 2,
  shadowColor: '',
  shadowTransparent: 0,
  shadowBlur: 0,
  shadowDistance: 0,
  left: 0,
  top: 0,
  rotate: 0,
  scale: 100,
  textTransparent: 100
})

const showBg = ref(false);
const showBorder = ref(false);
const showShadow = ref(false);

const onTextFormChange = () => {
  // console.log(form.value)
  emits('change', form.value);
}

return (_ctx: any,_cache: any) => {
  const _component_svgIcon = _resolveComponent("svgIcon")!
  const _component_el_color_picker = _resolveComponent("el-color-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_slider = _resolveComponent("el-slider")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[24] || (_cache[24] = _createElementVNode("div", { class: "title" }, "预设样式", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["color-item", form.value.class==''?'active':'']),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleSelectColor({class: ''})))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_svgIcon, {
              "icon-class": "ban",
              width: "1.4vw",
              height: "1.4vw"
            })
          ])
        ], 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(colorList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["color-item", form.value.class==item.class?'active':'']),
            key: index,
            onClick: ($event: any) => (handleSelectColor(item))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["color-item-inner radius-middle", item.class])
            }, "T", 2)
          ], 10, _hoisted_5))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[25] || (_cache[25] = _createElementVNode("div", { class: "title" }, "字符", -1)),
      _createVNode(_component_el_form, {
        modelValue: form.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form).value = $event)),
        inline: true
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "颜色",
            style: {"width":"48%","margin":"0px","margin-right":"4%"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_el_color_picker, {
                  modelValue: form.value.color,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.color) = $event)),
                  onChange: onTextFormChange
                }, null, 8, ["modelValue"]),
                _createElementVNode("span", _hoisted_8, _toDisplayString(form.value.color), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "字号",
            style: {"width":"48%","margin":"0px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input_number, {
                modelValue: form.value.fontSize,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.fontSize) = $event)),
                min: 8,
                max: 30,
                "controls-position": "right",
                onChange: onTextFormChange
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _cache[26] || (_cache[26] = _createTextVNode("背景色 ")),
        _createVNode(_component_el_checkbox, {
          modelValue: showBg.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showBg).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      (showBg.value)
        ? (_openBlock(), _createBlock(_component_el_form, {
            key: 0,
            modelValue: form.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form).value = $event)),
            inline: true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "颜色",
                style: {"width":"48%","margin":"0px","margin-right":"4%"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_el_color_picker, {
                      modelValue: form.value.backgroundColor,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.backgroundColor) = $event)),
                      onChange: onTextFormChange
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(form.value.backgroundColor), 1)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _cache[27] || (_cache[27] = _createTextVNode("描边 ")),
        _createVNode(_component_el_checkbox, {
          modelValue: showBorder.value,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((showBorder).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      (showBorder.value)
        ? (_openBlock(), _createBlock(_component_el_form, {
            key: 0,
            modelValue: form.value,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form).value = $event)),
            inline: true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "颜色",
                style: {"width":"48%","margin":"0px","margin-right":"4%"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_el_color_picker, {
                      modelValue: form.value.stroke,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.stroke) = $event)),
                      onChange: onTextFormChange
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(form.value.color), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "描边粗细",
                style: {"width":"48%","margin":"0px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input_number, {
                    modelValue: form.value.strokeWidth,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.strokeWidth) = $event)),
                    min: 1,
                    max: 10,
                    "controls-position": "right",
                    onChange: onTextFormChange
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _cache[28] || (_cache[28] = _createTextVNode("阴影 ")),
        _createVNode(_component_el_checkbox, {
          modelValue: showShadow.value,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((showShadow).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      (showShadow.value)
        ? (_openBlock(), _createBlock(_component_el_form, {
            key: 0,
            modelValue: form.value,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((form).value = $event)),
            inline: true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "颜色",
                style: {"width":"48%","margin":"0px","margin-right":"4%"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_el_color_picker, {
                      modelValue: form.value.shadowColor,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.value.shadowColor) = $event)),
                      onChange: onTextFormChange
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(form.value.color), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "不透明度",
                style: {"width":"48%","margin":"0px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input_number, {
                    modelValue: form.value.shadowTransparent,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.value.shadowTransparent) = $event)),
                    min: 0,
                    max: 100,
                    "controls-position": "right",
                    onChange: onTextFormChange
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "角度",
                style: {"width":"100%","margin-top":"1.2vh"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_slider, {
                    modelValue: form.value.shadowAngle,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.value.shadowAngle) = $event)),
                    min: 0,
                    max: 360,
                    "show-input": "",
                    size: "small",
                    onChange: onTextFormChange
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "模糊",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_slider, {
                    modelValue: form.value.shadowBlur,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.value.shadowBlur) = $event)),
                    min: 0,
                    max: 10,
                    "show-input": "",
                    size: "small",
                    onChange: onTextFormChange
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "距离",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_slider, {
                    modelValue: form.value.shadowDistance,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.value.shadowDistance) = $event)),
                    min: 0,
                    max: 10,
                    "show-input": "",
                    size: "small",
                    onChange: onTextFormChange
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_21, [
      _cache[32] || (_cache[32] = _createElementVNode("div", { class: "title" }, "基础调节", -1)),
      _createVNode(_component_el_form, {
        modelValue: form.value,
        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((form).value = $event)),
        "label-width": "2.4vw"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "坐标",
            style: {"width":"100%","margin":"0px","margin-right":"4%","margin-top":"1.2vh"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.value.left,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((form.value.left) = $event)),
                "suffix-icon": "X",
                style: {"width":"45%","margin-right":"5%"},
                onChange: onTextFormChange
              }, {
                append: _withCtx(() => _cache[29] || (_cache[29] = [
                  _createTextVNode("X")
                ])),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_input, {
                modelValue: form.value.top,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((form.value.top) = $event)),
                "suffix-icon": "Y",
                style: {"width":"45%"},
                onChange: onTextFormChange
              }, {
                append: _withCtx(() => _cache[30] || (_cache[30] = [
                  _createTextVNode("Y")
                ])),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "旋转",
            style: {"width":"100%","margin":"0px","margin-top":"1.2vh"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.value.rotate,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((form.value.rotate) = $event)),
                style: {"width":"95%"},
                onChange: onTextFormChange
              }, {
                append: _withCtx(() => _cache[31] || (_cache[31] = [
                  _createTextVNode("°")
                ])),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "缩放",
            style: {"width":"100%","margin-top":"1.2vh"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_slider, {
                modelValue: form.value.scale,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((form.value.scale) = $event)),
                min: 0,
                max: 100,
                "show-input": "",
                size: "small",
                style: {"margin-left":"10px"},
                onChange: onTextFormChange
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "透明",
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_slider, {
                modelValue: form.value.textTransparent,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((form.value.textTransparent) = $event)),
                min: 0,
                max: 100,
                "show-input": "",
                size: "small",
                style: {"margin-left":"10px"},
                onChange: onTextFormChange
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})